
import Auth from "@/lib/common/auth";
import VirRequest, {
  VirGetParam,
  VirListParam
} from "@/lib/model/vir/VirRequest";
import { Component, Vue } from "vue-property-decorator";
import _ from "lodash-es";

@Component({
  components: {}
})
export default class VirManage extends Vue {
  name = "vir-manage";
  searchTitle = "";
  searchText = "";
  virListParam = new VirListParam();
  virDelForm = new VirGetParam();
  hasNoList = false;
  dataList = [];
  tableLoading = false;
  page = 1;
  currentPageSize = 10;
  total = 0;

  rowStyle = {
    color: "#8B8F94",
    "font-weight": "400",
    "font-size": "14px"
  };

  mounted() {
    this.getDataList();
  }

  getDataList() {
    this.virListParam.companyId = parseInt(Auth.companyId);
    this.virListParam.titleLike = this.searchTitle;
    this.virListParam.textLike = this.searchText;

    VirRequest.virList(this.virListParam).then(res => {
      if (res.code === 0) {
        this.total = res.data.count;
        this.dataList = res.data.list;
        this.hasNoList = false;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  formatVirType(val: string) {
    if (val === "mp4") {
      return "视频";
    } else {
      return "音频";
    }
  }

  formatVirStatus(val: number) {
    if (val === 255) {
      return "合成失败";
    } else if (val <= 3 && val >= 0) {
      return "合成中";
    } else if (val === 4) {
      return "合成成功";
    } else {
      return "合成状态未知：" + val;
    }
  }

  reCreate(virId: number) {
    // this.tableLoading = true;
    this.virDelForm.companyId = parseInt(Auth.companyId);
    this.virDelForm.virId = virId;
    // 点击重新制作，应该跳转到制作视频页面
    this.$router.push("/vir/manual");
    // VirRequest.virCopy(this.virDelForm)
    //   .then(res => {
    //     if (res.code === 0) {
    //       this.$message.success("成功");
    //     } else {
    //       this.$message.error(res.message);
    //     }
    //   })
    //   .finally(() => {
    //     this.getDataList();
    //     this.tableLoading = false;
    //   });
  }

  delVirMp4(virId: number) {
    this.tableLoading = true;
    this.virDelForm.companyId = parseInt(Auth.companyId);
    this.virDelForm.virId = virId;
    VirRequest.virDelete(this.virDelForm)
      .then(res => {
        if (res.code === 0) {
          this.$message.success("删除成功");
        } else {
          this.$message.error(res.message);
        }
      })
      .finally(() => {
        this.getDataList();
        this.tableLoading = false;
      });
  }

  copyVirMp4(url: string) {
    //创建input标签
    const input = document.createElement("input");
    //将input的值设置为需要复制的内容
    input.value = url;
    //添加input标签
    document.body.appendChild(input);
    //选中input标签
    input.select();
    //执行复制
    document.execCommand("copy");
    //移除input标签
    document.body.removeChild(input);
    this.$message.success("复制成功");
  }

  playVirMp4(url: string) {
    window.open(url);
  }

  searchVir() {
    console.log("searchVir");
  }

  formatSeconds(value: number) {
    let theTime = value; // 秒
    let middle = 0; // 分
    let hour = 0; // 小时

    if (theTime > 60) {
      middle = Number(theTime / 60);
      theTime = Number(theTime % 60);
      if (middle > 60) {
        hour = Number(middle / 60);
        middle = Number(middle % 60);
      }
    }
    let result = "" + Number(theTime) + "秒";
    if (middle > 0) {
      result = "" + Number(middle) + "分" + result;
    }
    if (hour > 0) {
      result = "" + Number(hour) + "小时" + result;
    }
    return result;
  }

  virStatusColor(val: number) {
    if (val === 255) {
      return "audit-color-4";
    } else if (val <= 3 && val >= 0) {
      return "audit-color-2";
    } else if (val === 4) {
      return "audit-color-1";
    } else {
      return "audit-color-3";
    }
  }
}
